// JWT utility functions for OAuth 2.1 access tokens. Decodes payloads
// client-side; signature verification is the server's job.
//
// Ported from Workbench origin/main@60e779e:src/utils/jwt.js unchanged.

export function decodeJwtPayload(token) {
  try {
    if (!token || typeof token !== 'string') return null
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4)
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}

// Falls back to `sub` when `email` is absent — defensive only. The right fix
// when this happens is to request `scope=email` at /oauth2/authorize so the
// AS's JwtAccessTokenCustomizer emits the claim. See ops auth doc §4.5.
export function emailFromToken(token) {
  const payload = decodeJwtPayload(token)
  return payload?.email || payload?.sub || null
}

// Keycloak stores roles in realm_access.roles.
export function isAdminFromToken(token) {
  const payload = decodeJwtPayload(token)
  if (!payload) return false
  const roles = payload?.realm_access?.roles || []
  return roles.includes('admin')
}

export function getTokenExpiry(token) {
  const payload = decodeJwtPayload(token)
  if (!payload?.exp) return null
  return new Date(payload.exp * 1000)
}

export function isTokenExpiringSoon(token, withinSeconds = 60) {
  const expiry = getTokenExpiry(token)
  if (!expiry) return true
  return (expiry.getTime() - Date.now()) < (withinSeconds * 1000)
}
